<template>
    <div class="b_similar_articles">
        <div class="similar_articles">
            <div class="block_title">
                <h3>
                    {{ title || $t('articles.similarArticles') }}
                </h3>
            </div>
            <div class="articles flex">
                <template v-for="topicType in allTopics">
                    <similar-item-bottom-section
                        v-for="item in topicType.items"
                        :key="item.id"
                        :item="item"
                        :type="topicType.type"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SimilarTopicsBase from './SimilarTopicsBase';
import SimilarItemBottomSection from './SimilarItemBottomSection';

export default {
    components: {
        SimilarItemBottomSection
    },

    extends: SimilarTopicsBase
};
</script>
